import ReactMarkdown from 'react-markdown'
import type { Components } from 'react-markdown'
import remarkGfm from 'remark-gfm'
import { cn } from '@/lib/utils'

// HTML brut JAMAIS rendu (`skipHtml`, pas de rehype-raw) : pas de XSS via la
// sortie du LLM.
// Images JAMAIS chargées automatiquement : `![alt](url)` venant du LLM
// permettrait une exfiltration par requête GET (tracking pixel). L'élément est
// retiré (`unwrapDisallowed` : un `<img>` n'a pas d'enfant, rien n'est rendu).
const DISALLOWED_ELEMENTS = ['img']
const MARKDOWN_COMPONENTS: Components = {
  a: ({ node: _node, className, ...props }) => (
    <a
      {...props}
      target="_blank"
      rel="noopener noreferrer"
      className={cn(
        'text-violet-700 underline underline-offset-2 hover:text-violet-900 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-violet-500 focus-visible:ring-offset-2 rounded-sm',
        className
      )}
    />
  ),
  p: ({ node: _node, className, ...props }) => (
    <p {...props} className={cn('leading-relaxed [&:not(:first-child)]:mt-2', className)} />
  ),
  ul: ({ node: _node, className, ...props }) => (
    <ul {...props} className={cn('my-2 list-disc space-y-1 pl-5', className)} />
  ),
  ol: ({ node: _node, className, ...props }) => (
    <ol {...props} className={cn('my-2 list-decimal space-y-1 pl-5', className)} />
  ),
  table: ({ node: _node, className, ...props }) => (
    <div className="my-2 overflow-x-auto">
      <table {...props} className={cn('w-full border-collapse text-xs', className)} />
    </div>
  ),
  th: ({ node: _node, className, ...props }) => (
    <th {...props} className={cn('border border-slate-200 bg-slate-50 px-2 py-1 text-left font-medium', className)} />
  ),
  td: ({ node: _node, className, ...props }) => (
    <td {...props} className={cn('border border-slate-200 px-2 py-1', className)} />
  ),
  code: ({ node: _node, className, ...props }) => (
    <code {...props} className={cn('rounded bg-slate-100 px-1 py-0.5 font-mono text-[0.85em]', className)} />
  ),
  pre: ({ node: _node, className, ...props }) => (
    <pre {...props} className={cn('my-2 overflow-x-auto rounded-md bg-slate-100 p-3 text-xs [&>code]:bg-transparent [&>code]:p-0', className)} />
  ),
}

export type MarkdownContentProps = {
  content: string
  className?: string
}

export function MarkdownContent({ content, className }: MarkdownContentProps) {
  return (
    <div className={cn('text-sm text-slate-800 break-words', className)}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        skipHtml
        disallowedElements={DISALLOWED_ELEMENTS}
        unwrapDisallowed
        components={MARKDOWN_COMPONENTS}
      >
        {content}
      </ReactMarkdown>
    </div>
  )
}
